import axios from 'axios'

const HTTP = axios.create({
  baseURL: process.env.api
})

export default HTTP



// WEBPACK FOOTER //
// ./src/common/HTTP.js